import { Injectable } from '@angular/core';
import { AuthUtil } from '../utils/auth.utils';
import { AuthIdentityService } from './auth-identity.service';
import { AuthIdentityResponse } from '../models/interfaces/auth-response.interface';

@Injectable()
export class SelectTenantService {

  constructor(
    private readonly authIdentityService: AuthIdentityService,
    private readonly authUtil: AuthUtil,
  ) { }

  isTenantSelected(): boolean {
    if (
      this.getTenant() != null &&
      this.getTenant() != ''
    ) {
      return true;
    }
    return false;
  }

  getTenant(): string {
    return this.authUtil.getTenant();
  }

  getIdentities(): AuthIdentityResponse[] {
    return this.authUtil.getIdentities();
  }

  async selectIdentity(identity: AuthIdentityResponse): Promise<void> {
    try {
      await this.authIdentityService.fetchAndSaveData(identity)
    } catch (error) {
      throw error
    }
  }
}
